// src/App.tsx
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Home } from './components/Home';
import { Offer } from './components/offer';
import {AI} from './components/ai';
import { TelegramApp } from './components/TelegramApp';
import { Affiliate } from './components/affilater';
function App() {
  return (
    <Router>
      <Routes>
        {/* Главная страница по маршруту /home */}
        <Route path="/offer" element={<Offer />} />
        <Route path="/" element={<Home />} />
        <Route path="/ai" element={<AI />} />
        <Route path="/affiliate" element={<Affiliate />} />
        <Route path="/telegram" element={<TelegramApp />} />
        {/* Другие маршруты */}
        <Route path="*" element={<Navigate to="/home" replace />} />
      </Routes>
    </Router>
  );
}

export default App;